import React, { Component } from "react";

const AskTheExpert = () => {
  return <h1>Ask The Expert</h1>;
};

export default AskTheExpert;
